import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StudentapiService } from '../studentapi.service';
@Component({
  selector: 'app-print-data',
  templateUrl: './print-data.component.html',
  styleUrls: ['./print-data.component.css']
})
export class PrintDataComponent implements OnInit {
  selctform !: FormGroup;
  rsultdata: any;

  erno: any;
  stud: any;
  seat: any;
  stname: any;
  stream: any;
  hsscdata: any;
  ssub1: any;
  s1name: any;
  s2name: any;
  s3name: any;
  s4name: any;
  s5name: any;
  s6name: any;
  s7name: any;
  result:any;
  s1thext: any;
  s1thextg: any;
  s1thint: any;
  sb1x: any;
  sb1gr: any;
  s2thext: any;
  s2thextg: any;
  s2thint: any;
  sb2gr: any;
  sb2x: any;
  s3thext: any;
  s3thextg: any;
  s3thint: any;
  sb3gr: any;
  sb3x: any;
  s4thext: any;
  s4thextg: any;
  s4thint: any;
  sb4gr: any;
  sb4x: any;
  s5thext: any;
  s5thextg: any;
  s5thint: any;
  sb5gr: any;
  sb5x: any;
  s6thext: any;
  s6thextg: any;
  s6thint: any;
  sb6gr: any;
  sb6x: any;
  s7thext: any;
  s7thextg: any;
  s7thint: any;

  sb7x: any;
  sb7gr: any;
  ttl: any;
  exam: any;
  sb1th: any;
  sb1p: any;
  sb1pit: any;
  sb1prc: any;
  sb2p: any;
  sb2pit: any;
  sb2prc: any;
  sb3p: any;
  sb3pit: any;
  sb3prc: any;
  sb4p: any;
  sb4pit: any;
  sb4prc: any;
  sb5p: any;
  sb5pit: any;
  sb5prc: any;
  sb6p: any;
  sb6pit: any;
  sb6prc: any;
  sb7p: any;
  sb7pit: any;
  sb7prc: any;
  sb5th: any;
  sb5tgr: any;
  hsscselctform!: FormGroup;
  scode: null;
  teststud: any;
  sscrs: any;
  sscstudres: any;
  ftname: any;
  mtname: any;
  cdtbt: any;
  sbex1: any;
  sb1pgr: any;
  sb2th: any;
  sb3th: any;
  sb4th: any;
  sb6th: any;
  sb7th: any;
  sb2pgr: any;
  sb3pgr: any;
  sb4pgr: any;
  sb5pgr: any;
  sb6pgr: any;
  sb7pgr: any;
  sb1tgr: any;
  sb2tgr: any;
  sb3tgr: any;
  sb4tgr: any;
  sb6tgr: any;
  sb7tgr: any;
  centre: any;
  

  constructor(public formbuilder:FormBuilder,public router:Router, private api:StudentapiService) { }

  ngOnInit(): void {
    this.selctform = this.formbuilder.group({
      seat:[''],
      
    });
  }

  OnResultSubmit()
  {
    let stud :{ seat :any} ={
      seat : this.selctform.controls.seat.value
    }

    console.log(stud);

    return this.api.post('/StudentApi/resultrecord',stud).subscribe((res:any)=>{
      //  alert(JSON.stringify(this.rsultdata));
       this.rsultdata =  res['Data'];

       console.log(res);
      
       this.seat = this.rsultdata[0].seat;
       this.centre = this.rsultdata[0].centre;
       this.scode = this.rsultdata[0].scode;
       this.stname = this.rsultdata[0].stname;
       this.stream = this.rsultdata[0].stream;
       this.s1name = this.rsultdata[0].s1name;
       this.s2name = this.rsultdata[0].s2name;
       this.s3name = this.rsultdata[0].s3name;
       this.s4name = this.rsultdata[0].s4name;
       this.s5name = this.rsultdata[0].s5name;
       this.s6name = this.rsultdata[0].s6name;
       this.s7name = this.rsultdata[0].s7name;
       this.s1thext = this.rsultdata[0].s1thext;
       this.s1thextg = this.rsultdata[0].s1thextg;
       this.s1thint  = this.rsultdata[0].s1thint;
       this.sb1x  = this.rsultdata[0].sb1x;
       this.sb1th = this.rsultdata[0].sb1th;
       this.sb1tgr = this.rsultdata[0].sb1tgr;
       this.sb1pgr = this.rsultdata[0].sb1pgr;
       this.sbex1 = this.rsultdata[0].sbex1;
       this.sb1gr  = this.rsultdata[0].sb1gr;
       this.s2thext = this.rsultdata[0].s2thext;
       this.s2thextg = this.rsultdata[0].s2thextg;
       this.s2thint  = this.rsultdata[0].s2thint;
       this.sb2x  = this.rsultdata[0].sb2x;
       this.sb2th = this.rsultdata[0].sb2th;
       this.sb2tgr = this.rsultdata[0].sb2tgr;
       this.sb2pgr = this.rsultdata[0].sb2pgr;
       this.sb2gr  = this.rsultdata[0].sb2gr;
       this.s3thext = this.rsultdata[0].s3thext;
       this.s3thextg = this.rsultdata[0].s3thextg;
       this.s3thint  = this.rsultdata[0].s3thint;
       this.sb3x  = this.rsultdata[0].sb3x;
       this.sb3th  = this.rsultdata[0].sb3th;
       this.sb3tgr = this.rsultdata[0].sb3tgr;
       this.sb3pgr = this.rsultdata[0].sb3pgr;
       this.sb3gr  = this.rsultdata[0].sb3gr;
       this.s4thext = this.rsultdata[0].s4thext;
       this.s4thextg = this.rsultdata[0].s4thextg;
       this.s4thint  = this.rsultdata[0].s4thint;
       this.sb4x  = this.rsultdata[0].sb4x;
       this.sb4th = this.rsultdata[0].sb4th;
       this.sb4tgr = this.rsultdata[0].sb4tgr;
       this.sb4pgr = this.rsultdata[0].sb4pgr;
       this.sb4gr  = this.rsultdata[0].sb4gr;
       this.s5thext = this.rsultdata[0].s5thext;
       this.s5thextg = this.rsultdata[0].s5thextg;
       this.s5thint  = this.rsultdata[0].s5thint;
       this.sb5x  = this.rsultdata[0].sb5x;
       this.sb5th = this.rsultdata[0].sb5th;
       this.sb5tgr = this.rsultdata[0].sb5tgr;
       this.sb5pgr = this.rsultdata[0].sb5pgr;
       this.sb5gr  = this.rsultdata[0].sb5gr;
       this.s6thext = this.rsultdata[0].s6thext;
       this.s6thextg = this.rsultdata[0].s6thextg;
       this.s6thint  = this.rsultdata[0].s6thint;
       this.sb6x  = this.rsultdata[0].sb6x;
       this.sb6th =this.rsultdata[0].sb6th;
       this.sb6tgr = this.rsultdata[0].sb6tgr;
       this.sb6pgr = this.rsultdata[0].sb6pgr;
       this.sb6gr  = this.rsultdata[0].sb6gr;
       this.s7thext = this.rsultdata[0].s7thext;
       this.s7thextg = this.rsultdata[0].s7thextg;
       this.s7thint  = this.rsultdata[0].s7thint;
       this.sb7x  = this.rsultdata[0].sb7x;
       this.sb7th = this.rsultdata[0].sb7th;
       this.sb7tgr = this.rsultdata[0].sb7tgr;
       this.sb7pgr = this.rsultdata[0].sb7pgr;
       this.sb7gr  = this.rsultdata[0].sb7gr;
       // practical marks
       this.sb1p  = this.rsultdata[0].sb1p;
       this.sb1pit  = this.rsultdata[0].sb1pit;
       this.sb1prc = this.rsultdata[0].sb1prc;
       this.sb2p  = this.rsultdata[0].sb2p;
       this.sb2pit  = this.rsultdata[0].sb2pit;
       this.sb2prc = this.rsultdata[0].sb2prc;
       this.sb3p  = this.rsultdata[0].sb3p;
       this.sb3pit  = this.rsultdata[0].sb3pit;
       this.sb3prc = this.rsultdata[0].sb3prc;
       this.sb4p  = this.rsultdata[0].sb4p;
       this.sb4pit  = this.rsultdata[0].sb4pit;
       this.sb4prc = this.rsultdata[0].sb4prc;
       this.sb5p  = this.rsultdata[0].sb5p;
       this.sb5pit  = this.rsultdata[0].sb5pit;
       this.sb5prc = this.rsultdata[0].sb5prc;
       this.sb6p  = this.rsultdata[0].sb6p;
       this.sb6pit  = this.rsultdata[0].sb6pit;
       this.sb6prc = this.rsultdata[0].sb6prc;
       this.sb7p  = this.rsultdata[0].sb7p;
       this.sb7pit  = this.rsultdata[0].sb7pit;
       this.sb7prc = this.rsultdata[0].sb7prc;
       this.exam  = this.rsultdata[0].exam;
       this.ttl  = this.rsultdata[0].ttl;
       this.result = this.rsultdata[0].result;
       
       this.ftname = this.rsultdata[0].ftname;
       this.mtname = this.rsultdata[0].mtname;
       this.cdtbt = this.rsultdata[0].cdtbt;
     },
     err=>{
      alert('Error');
     });
  }
}
